import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PlaceCemetary } from '@fs/zion-icon/dist/cjs/icons'
import { getGroupSummary } from '../services/groupsService'
import useNotifications from './useNotifications'
import { getTree } from '../services/treeService'

const getTrees = async (treeIds, error, t) => {
  return Promise.allSettled(
    treeIds.map(async (treeId) => {
      let icon = null
      try {
        const treeResponse = await getTree(treeId)
        icon = treeResponse.data.tombstoned ? PlaceCemetary : null
      } catch (err) {
        error(t('hooks.errors.gettingTree', 'Error getting tree: {message}', { message: err.message || '' }), err)
      }
      return { value: treeId, icon }
    })
  )
}

export default function useGroup(groupId) {
  const { t } = useTranslation()
  const { error } = useNotifications()
  const [currentGroupData, setCurrentGroupData] = useState()

  const fetchCurrentGroupData = useCallback(async () => {
    const setMetadata = (oldMetadata) => {
      const items = []
      if (oldMetadata.groupId) {
        items.push({
          ...oldMetadata.groupId,
          label: t('groups.groupId', 'Group ID'),
          showLabel: true,
          field: 'groupId',
        })
      }

      let badges = null
      if (oldMetadata.tombstonedBadge) {
        badges = []
        badges.push({ ...oldMetadata.tombstonedBadge, field: 'tombstoned' })
      }
      return { header: oldMetadata.header, items, badges }
    }
    if (groupId) {
      try {
        const response = await getGroupSummary(groupId)
        const data = response.data
        data.metadata = setMetadata(data.metadata)
        let treeIds = []
        if (data.treeIds) {
          treeIds = await getTrees(data.treeIds, error, t)
        }
        data.treeIds = treeIds.map((treeId) => treeId.value)
        setCurrentGroupData(data)
      } catch (err) {
        error(
          t('hooks.errors.gettingGroup', {
            defaultValue: `Error getting group: ${err.message || ''}`,
            message: err.message || '',
          }),
          err
        )
      }
    }
  }, [groupId, error, t])

  useEffect(() => {
    fetchCurrentGroupData()
  }, [fetchCurrentGroupData])

  return { currentGroupData, fetchCurrentGroupData }
}
